const mapMatchingSearchParams = (
    isCreate,
    params,
) => {
    return new Promise((resolve) => {
        resolve({
            matching_search: {
                phrases: params.phrases,
            },
        });
    });
};

export { mapMatchingSearchParams };
